import styled from "styled-components";
import { P } from "../../../../../AbstractElements";

export const TableWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  background: #fff;

  .rdt_Table {
    border-radius: 8px !important;
  }

  .rdt_TableHeadRow {
    min-height: 42px;
    border-bottom: 1px solid #e5e7eb;
    background: #f8fafc;
  }

  .rdt_TableHeadRow .rdt_TableCol {
    color: #475569;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .rdt_TableRow {
    min-height: 58px;
    border-bottom: 1px solid #f1f5f9;
    transition:
      background-color 0.15s ease,
      box-shadow 0.15s ease;
  }

  .rdt_TableRow:hover {
    background: #f8fbff;
  }

  .rdt_TableCell {
    color: #334155;
    font-size: 12px;
    padding-left: 8px;
    padding-right: 8px;
  }

  .rdt_Pagination {
    border-top: 0 !important;
  }
`;

export const CellRow = styled.div<{ $hasError?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding-top: ${({ $hasError }) => ($hasError ? "0.5rem" : "0")};
`;

export const EditShell = styled.div<{ $hasError?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 74px;
  border: 1px solid ${({ $hasError }) => ($hasError ? "#e11d48" : "#d1d5db")};
  border-radius: 6px;
  padding: 0 7px;
  background: #fff;
  &:focus-within {
    border-color: ${({ $hasError }) => ($hasError ? "#e11d48" : "#3b82f6")};
    box-shadow: ${({ $hasError }) =>
      $hasError ? "none" : "0 0 0 2px rgba(59,130,246,0.15)"};
  }
`;

export const EditInput = styled.input`
  width: 100%;
  padding: 7px 0;
  border: 0;
  outline: none;
  font-size: 12px;
  font-weight: 500;
  background: transparent;
  &[type="number"]::-webkit-outer-spin-button,
  &[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const ErrorText = styled(P)`
  margin: 4px 0 0 0 !important;
  color: #e11d48;
  font-size: 11px;
`;

export const FullWidthCell = styled.div`
  width: 100%;
`;

export const ActionGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
`;

export const ActionIconButton = styled.button<{ $tone: "approve" | "reject" }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid
    ${({ $tone }) => ($tone === "approve" ? "#bbf7d0" : "#fecdd3")};
  border-radius: 6px;
  color: ${({ $tone }) => ($tone === "approve" ? "#15803d" : "#be123c")};
  background: ${({ $tone }) => ($tone === "approve" ? "#f0fdf4" : "#fff1f2")};
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    transform 0.15s ease;

  &:hover:not(:disabled) {
    background: ${({ $tone }) => ($tone === "approve" ? "#dcfce7" : "#ffe4e6")};
    border-color: ${({ $tone }) =>
      $tone === "approve" ? "#86efac" : "#fda4af"};
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const StatusIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #f8fafc;
`;

export const StatusPill = styled.span<{
  $tone: "pending" | "approved" | "rejected" | "neutral";
}>`
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 8px;
  border: 1px solid
    ${({ $tone }) =>
      $tone === "approved"
        ? "#bbf7d0"
        : $tone === "rejected"
        ? "#fecdd3"
        : $tone === "pending"
        ? "#fde68a"
        : "#e2e8f0"};
  border-radius: 999px;
  color: ${({ $tone }) =>
    $tone === "approved"
      ? "#15803d"
      : $tone === "rejected"
      ? "#be123c"
      : $tone === "pending"
      ? "#a16207"
      : "#475569"};
  background: ${({ $tone }) =>
    $tone === "approved"
      ? "#f0fdf4"
      : $tone === "rejected"
      ? "#fff1f2"
      : $tone === "pending"
      ? "#fffbeb"
      : "#f8fafc"};
  font-size: 10px;
  font-weight: 500;
  text-transform: capitalize;
`;

export const ApprovalState = styled.span<{ $tone?: "approve" | "reject" }>`
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 8px;
  border-radius: 999px;
  color: ${({ $tone }) =>
    $tone === "approve" ? "#15803d" : $tone === "reject" ? "#be123c" : "#64748b"};
  background: ${({ $tone }) =>
    $tone === "approve" ? "#f0fdf4" : $tone === "reject" ? "#fff1f2" : "#f8fafc"};
  font-size: 10px;
  font-weight: 500;
`;
